<template>
	<div>
		<slick :options="slickOptions" class="carousel" ref="carousel">

			<slot></slot>

		</slick>

		<div class="arrows d-none d-md-block">

			<button class="btn prev" @click="prev">

			</button>

			<button class="btn next" @click="next">

			</button>
		</div>
	</div>
</template>

<script>

import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css'

export default {

    name: "HeroSlider",
	components: { Slick },
    props: [],

    data(){
        return {
	        slickOptions:{
	        	dots:true,
		        autoplay:false,
		        arrows:false
	        }

        }
    },

    mounted(){



    },

    methods: {

        //...mapMutations(['isMobile']),
	    prev() {
		    this.$refs.carousel.prev()
	    },
	    next() {
		    this.$refs.carousel.next()
	    },
    },

    computed: {

        //...mapState(['locale','storage','isMobile']),


    },
}
</script>

<style scoped>

</style>
